if (!customElements.get('novelia-shipping-insurance')) {
  customElements.define('novelia-shipping-insurance', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      if (!this.input || this.bound) return;
      this.bound = true;
      this.addEventListener('change', event => {
        event.stopPropagation();
        if (event.target === this.input) this.update(this.input.checked ? 1 : 0, true);
      });
      const quantity = Number(this.dataset.quantity);
      if (quantity && (!Number(this.dataset.physicalCount) || quantity > 1)) {
        this.update(Number(this.dataset.physicalCount) ? 1 : 0, false);
      }
    }
    async update(quantity, focus) {
      if (this.busy) return;
      this.busy = true;
      const previous = Number(this.dataset.quantity) > 0;
      const drawer = this.closest('cart-drawer');
      const checkout = drawer?.querySelector('[name="checkout"]');
      const checkoutWasDisabled = checkout?.disabled;
      this.setAttribute('aria-busy', 'true');
      this.input.disabled = true;
      if (checkout) checkout.disabled = true;
      this.querySelector('[role="status"]').textContent = '';
      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(root + 'cart.js');
        if (!cartResponse.ok) throw new Error('cart');
        const cart = await cartResponse.json();
        const variant = Number(this.dataset.variantId);
        const physical = cart.items.some(item => item.requires_shipping && item.variant_id !== variant);
        if (!physical) quantity = 0;
        const existing = cart.items.filter(item => item.variant_id === variant);
        const updates = {};
        existing.forEach((item, index) => { updates[item.key] = index === 0 ? quantity : 0; });
        if (!existing.length) updates[variant] = quantity;
        const response = await fetch(root + 'cart/update.js', {
          method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({updates, sections: ['cart-drawer','cart-icon-bubble'], sections_url: location.pathname})
        });
        const state = await response.json();
        if (!response.ok || state.errors) throw new Error('update');
        if (!state.sections?.['cart-drawer'] || !state.sections?.['cart-icon-bubble']) {
          location.reload();
          return;
        }
        drawer.classList.toggle('is-empty', state.item_count === 0);
        drawer.renderContents(state);
        if (focus) requestAnimationFrame(() => document.getElementById('NoveliaInsurance')?.focus());
      } catch (error) {
        this.input.checked = previous;
        this.querySelector('[role="status"]').textContent = this.dataset.error;
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        this.input.disabled = !Number(this.dataset.physicalCount);
        if (checkout?.isConnected) checkout.disabled = checkoutWasDisabled;
      }
    }
  });
}
